module.exports = __webpack_public_path__ + "img/aostest.01d29621.svg";